import React, { useState } from 'react';
import Button from '../components/Button';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Basic validation
        if (!formData.name || !formData.email || !formData.message) {
            alert('Please fill in all required fields');
            return;
        }
        alert('Thank you for your message! We will contact you soon.');
        setFormData({ name: '', email: '', phone: '', message: '' });
    };

    return (
        <>
            {/* Hero Section */}
            <section className="hero" style={{ minHeight: '60vh' }}>
                <div className="hero-content">
                    <h1 className="hero-title">Contact Us</h1>
                    <p className="hero-subtitle">We're Here to Help You Begin Your Journey</p>
                </div>
            </section>

            {/* Contact Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">Get In Touch</h2>
                </div>

                <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                    <div className="cards-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
                        <div className="card">
                            <div className="card-icon">📧</div>
                            <h3 className="card-title">Email</h3>
                            <p className="card-text">silambamacademy@example.com</p>
                        </div>
                        <div className="card">
                            <div className="card-icon">📱</div>
                            <h3 className="card-title">WhatsApp</h3>
                            <p className="card-text">+91 6383 836 429</p>
                        </div>
                        <div className="card">
                            <div className="card-icon">🕒</div>
                            <h3 className="card-title">Response Time</h3>
                            <p className="card-text">Within 24 hours</p>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} style={{ marginTop: '3rem' }} className="contact-form">
                        <div className="form-group">
                            <label className="form-label" htmlFor="name">Name *</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="form-input"
                                required
                                placeholder="Your full name"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="email">Email *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-input"
                                required
                                placeholder="your.email@example.com"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="phone">Phone</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="+91 6383836429"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="message">Message *</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                className="form-textarea"
                                required
                                placeholder="Tell us how we can help you..."
                            ></textarea>
                        </div>

                        <Button type="submit" style={{ width: '100%', marginTop: '1rem' }}>Send Message</Button>
                    </form>
                </div>
            </section>
        </>
    );
};

export default Contact;
